import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Select, message, Spin, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getAmenities } from "../../features/amenitySlice";
import App from "../../Utils/LayoutMobile";
import {
  fetchLocationById,
  updateLocation,
} from "../../features/locationSlice";
import { useNavigate, useParams } from "react-router-dom";

const { Option } = Select;

const UpdateLocationForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [amenitiesOptions, setAmenitiesOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialImages, setInitialImages] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [amenities, location] = await Promise.all([
          dispatch(getAmenities()).unwrap(),
          dispatch(fetchLocationById(id)).unwrap(),
        ]);

        setAmenitiesOptions(amenities);

        // Pre-fill form
        form.setFieldsValue({
          title: location.title,
          address: location.address,
          link: location.link,
          amenities: location.amenities?.map((a) => a._id),
          description: location.description,
          venue: {
            capacity: {
              area: location.venue?.capacity?.area,
              carParking: location.venue?.capacity?.carParking,
            },
            info: location.venue?.info,
          },
        });

        // Format imageList for Upload component
        if (location.imageList?.length) {
          const fileList = location.imageList.map((img, index) => ({
            uid: String(index),
            name: `image-${index}.jpg`,
            status: "done",
            url: img.url,
          }));
          setInitialImages(fileList);
          form.setFieldsValue({ imageList: fileList });
        }
      } catch (error) {
        message.error("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleSubmit = (values) => {

    try {
      console.log("::values:::", values)
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("address", values.address || "");
      formData.append("link", values.link || "");
      values.amenities?.forEach((id) => formData.append("amenities", id));
      formData.append("description", values.description || "");

      // Venue
      formData.append("venue[capacity][area]", values.venue?.capacity?.area || "");
      formData.append(
        "venue[capacity][carParking]",
        values.venue?.capacity?.carParking || ""
      );

      if (typeof values.venue?.info === "string") {
        try {
          const parsed = JSON.parse(values.venue.info);
          Object.keys(parsed).forEach((key) =>
            formData.append(`venue[info][${key}]`, parsed[key])
          );
        } catch {
          message.warning("Invalid JSON in additional info");
        }
      }

      // Handle image uploads
      const existingImages = [];
      values.imageList?.forEach((file) => {
        if (file.originFileObj) {
          // New image to upload
          formData.append("imageList", file.originFileObj);
        } else if (file.url && file.public_id) {
          // Previously uploaded image to keep
          existingImages.push({ url: file.url, public_id: file.public_id });
        }
      });

      // Attach existing image metadata as JSON string
      formData.append("existingImages", JSON.stringify(existingImages));
      console.log("form data is start")
      // Log formData
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      setLoading(true);
      dispatch(updateLocation({ id, data: formData }))
        .unwrap()
        .then(() => {
          message.success("Location updated successfully");
          navigate("/location");
        })
        .catch((err) => {
          console.log("::error update location::", err)
          message.error(err?.message || "Update failed");
          setLoading(false);
        });
    }
    catch (error) {
      console.log(":::error::", error)
    }

  };

  return (
    <App>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <h2 style={{ marginBottom: 30 }}>Update Location</h2>
        </Col>
      </Row>
      <Spin spinning={loading}>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item name="title" label="Title" rules={[{ required: true }]}>
                <Input placeholder="Enter location title" />
              </Form.Item></Col>
            <Col xs={24} md={12}>
              <Form.Item name="address" label="Address">
                <Input placeholder="Enter address" />
              </Form.Item></Col>
          </Row>

          <Row>


            <Col xs={24} md={12}>  <Form.Item
              name="imageList"
              label="Upload Images"
              valuePropName="fileList"
              getValueFromEvent={(e) => e?.fileList}
            >
              <Upload
                beforeUpload={() => false}
                listType="picture"
                multiple
                defaultFileList={initialImages}
              >
                <Button icon={<UploadOutlined />}>Upload Images</Button>
              </Upload>
            </Form.Item></Col>
            <Col xs={24} md={12}>
              <Form.Item name="address" label="Address">
                <Input placeholder="Enter address" />
              </Form.Item>
            </Col>
          </Row>


          {/* 
          <Form.Item
            name="amenities"
            label="Select Amenities"
            rules={[{ required: true, message: "Please select amenities" }]}
          >
            <Select
              mode="multiple"
              placeholder="Select amenities"
              loading={loading}
              allowClear
            >
              {amenitiesOptions?.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item> */}
          <Row gutter={16}>
            <Col xs={24} md={12}> <Form.Item name="link" label="Map Link">
              <Input placeholder="Optional map link" />
            </Form.Item></Col>
            <Col xs={24} md={12}> <Form.Item label="Venue Capacity">
              <Input.Group compact>
                <Form.Item name={["venue", "capacity", "area"]} noStyle>
                  <Input
                    style={{ width: "50%" }}
                    placeholder="Area (e.g. 5000 sq ft)"
                  />
                </Form.Item>
                <Form.Item name={["venue", "capacity", "carParking"]} noStyle>
                  <Input
                    style={{ width: "50%" }}
                    placeholder="Car Parking (e.g. 100 cars)"
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item></Col>
          </Row>


          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} placeholder="Enter description" />
          </Form.Item>



          {/* <Form.Item name={["venue", "info"]} label="Additional Info (JSON)">
            <Input.TextArea rows={3} placeholder='e.g. {"stage": "yes"}' />
          </Form.Item> */}

          <Form.Item style={{ display: "flex", justifyContent: "space-between" }}>
            <Button className="m-2" onClick={() => navigate("/location")}>Cancel</Button>
            <Button className='m-2' type="primary" htmlType="submit">
              Update Location
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </App>
  );
};

export default UpdateLocationForm;
